<template>
    <client-page class="app--main">
        <section class="section pt-40">
            <v-container class="container--large">
                <recruitment-list-search class="mb-40" />
                <v-row class="my-10">
                    <v-spacer />
                    <v-col cols="auto">
                        <recruitment-list-sort outlined solo flat prepend-inner-icon="mdi-sort" />
                    </v-col>
                </v-row>

                <template v-if="items?.length">
                    <div class="recruitment-cards">
                        <v-card rounded="lg" outlined v-for="item in items" :key="item._id" :to="`/recruitments/${item._id}`" class="recruitment-card">
                            <v-row>
                                <!-- image area -->
                                <v-col cols="12" md="3" class="mb-n30 mb-md-0">
                                    <div class="w-100 h-100 border-md-end d-flex align-center justify-center pa-20">
                                        <v-img :aspect-ratio="180 / 60" max-width="180" width="180" height="60" contain :src="item?.company?.logo?.url">
                                            <template #placeholder>
                                                <v-layout justify-center align-center class="h-100 text-center">
                                                    {{ item?.company?.name }}
                                                </v-layout>
                                            </template>
                                        </v-img>
                                    </div>
                                </v-col>
                                <!-- info area -->
                                <v-col cols="12" md="9">
                                    <div class="pa-20 pt-md-20 pl-md-10 pl-lg-0">
                                        <p class="page-text page-text--sm primary--text mb-4">{{ item?.company?.name }}</p>
                                        <h5 class="page-text--lg font-wieght-medium mb-8 mb-lg-16">
                                            {{ item?.subject }}
                                            <like-btn :params="{ _recruitment: item._id, type: USER_LIKE_TYPES.RECRUITMENT.value }">
                                                <template #activator="{ active, toggle }">
                                                    <v-btn icon text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                                                        <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                                    </v-btn>
                                                </template>
                                            </like-btn>
                                        </h5>
                                        <v-chip-group class="mb-4">
                                            <v-chip small outlined color="grey-d">
                                                <span class="grey-6--text">
                                                    {{ item.employment.typesTexts.join(" / ") }}
                                                </span>
                                            </v-chip>
                                        </v-chip-group>

                                        <p class="page-text grey-6--text ellip mb-8 mb-lg-16">{{ item?.summary }}</p>
                                        <recruitment-list-item-application v-bind="{ item }" />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card>
                    </div>

                    <!-- <v-card v-for="item in items" :key="item._id" outlined rounded="0" class="mb-16" :to="`${$route.path}/${item._id}`">
                        <v-row align="center" class="mx-0">
                            <v-col cols="auto">
                                <v-img width="180" height="60" :src="item?.company?.logo?.url">
                                    <template #placeholder> {{ item?.company?.name }} </template>
                                </v-img>
                            </v-col>
                            <v-col>
                                <v-card-subtitle class="pb-0">{{ item?.company?.name }}</v-card-subtitle>
                                <v-card-title>
                                    {{ item?.subject }}
                                    <like-btn :params="{ _recruitment: item._id, type: USER_LIKE_TYPES.RECRUITMENT.value }">
                                        <template #activator="{ active, toggle }">
                                            <v-btn icon text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                                                <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                            </v-btn>
                                        </template>
                                    </like-btn>
                                </v-card-title>
                                <v-card-text>
                                    <div v-if="item?.employment?.typesTexts">{{ item.employment.typesTexts.join(" / ") }}</div>
                                    <div>{{ item?.summary }}</div>
                                </v-card-text>
                            </v-col>
                            <v-col cols="auto">
                                <recruitment-list-item-application v-bind="{ item }" />
                            </v-col>
                        </v-row>
                    </v-card> -->

                    <div class="mt-40 mt-lg-60">
                        <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
                    </div>
                </template>

                <v-layout v-else column justify-center align-center class="page-text page-text--lg border-top pt-12 pt-lg-20"> 등록된 채용공고가 없습니다. </v-layout>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_LIST_SORTS, USER_LIKE_TYPES, RECRUITMENT_STATES } from "@/assets/variables";

import LikeBtn from "@/components/client/like/like-btn.vue";
import ClientPage from "../templates/ClientPage.vue";
import RecruitmentListSort from "@/components/client/recruitments/list/recruitment-list-sort.vue";
import RecruitmentListSearch from "@/components/client/recruitments/list/recruitment-list-search.vue";
import RecruitmentListItemApplication from "@/components/dashboard/company/recruitment-list-item-application.vue";

export default {
    components: {
        LikeBtn,
        ClientPage,
        RecruitmentListSort,
        RecruitmentListSearch,
        RecruitmentListItemApplication,
    },
    data: () => ({
        recruitments: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        showsSearch: true,
        USER_LIKE_TYPES,
    }),
    computed: {
        items() {
            return this.recruitments.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        sort() {
            const key = this.$route.query.sort || RECRUITMENT_LIST_SORTS.CREATED_AT_DESC.value;
            let { sort } = RECRUITMENT_LIST_SORTS[key] || {};

            if (sort) sort = JSON.stringify(sort);

            return sort;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            if (query.sort) {
                let sortParams = RECRUITMENT_LIST_SORTS[query.sort]?.params?.() || {};
                query = { ...query, ...sortParams };
                delete query.sort;
            }

            if (query?.["employment.place.address1"]) {
                if (!Array.isArray(query?.["employment.place.address1"])) {
                    query["employment.place.address1"] = [query?.["employment.place.address1"]].filter((item) => item);
                }
                if (query["employment.place.address1"].includes("전국")) {
                    query["employment.place.isAbroad"] = false;
                    delete query["employment.place.address1"];
                }
            }

            query["application.endsAt"] = [null, { $gte: Date.now() }];

            query.state = [RECRUITMENT_STATES.ON_GOING.value];
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, sort, params } = this;

                var { summary, recruitments } = await api.v1.recruitments.gets({
                    headers: { skip, limit, sort },
                    params,
                });

                this.recruitments = recruitments;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>


